export default "__VITE_ASSET__pgReWI3D__"